// App.js
import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import Layout from './Layout';
import TaxSearchForm from './TaxSearchForm';
import TaxSearchResults from './TaxSearchResults';
import PaymentsSearchForm from './PaymentsSearchForm';
import PaymentsSearchResults from './PaymentsSearchResults';
import PropertySearchResults from './PropertySearchResults';
import PropertyPage from './PropertyPage';
import HistoryPage from './HistoryPage';
import PropertyPaymentsPage from './PropertyPaymentsPage';
import TaxStatusPage from './TaxStatusPage';
import PropertyDetailPage from './PropertyDetailPage';
import TaxRollPage from './TaxRollPage';
import BillImagePage from './BillImagePage';
import TaxDetailPage from './TaxDetailPage';
import NotFound from './NotFound';
import UserList from './UserList';
import UserLayout from './UserLayout';
import UserForm from './UserForm';
import NewUserForm from './UserNewForm';
import NewCustomerForm from './CustomerNewForm';
import CustomerLayout from './CustomerLayout';
import CustomerForm from './CustomerForm';
import ClientList from './ClientList';
import LoginForm from './LoginForm';
import ForgotPasswordForm from './ForgotPasswordForm';
import ResetPasswordForm from './ResetPasswordForm';
import ProtectedRoute from './ProtectedRoute';
import ThankYou from './ThankYou';
import RequireProduct, { CustomerLanding } from './RequireProduct';

function App() {
  console.log('the current environment: ' + process.env.REACT_APP_ENV);
  return (
    <Routes>
      <Route path="/" element={<Layout />}>
        <Route index element={<NotFound />} />
        <Route path="customer/:customerId">
        {/* Landing Page */}
          <Route index element={<CustomerLanding />} />
          {/* Tax */}
          <Route path="taxSearch" element={<TaxSearchForm />} />
          <Route path="taxStatus/:taxid/:taxyear" element={<TaxStatusPage />} />
          <Route path="taxSearchResults" element={<TaxSearchResults />} />
          <Route path="taxDetail/:taxid/:taxyear" element={<TaxDetailPage />} />  
          <Route path="propertyDetail/:taxid/:taxyear" element={<PropertyDetailPage />} />           
          <Route path="taxRoll/:taxid/:taxyear" element={<TaxRollPage />} />        
          {/* Payments */}
          <Route path="paymentsSearch" element={<RequireProduct product="tpay"><PaymentsSearchForm /></RequireProduct>} />
          <Route path="paymentsSearchResults" element={<RequireProduct product="tpay"><PaymentsSearchResults /></RequireProduct>} />
          {/* Thank You */}
          <Route path="ThankYou" element={<ThankYou />} />
          {/* Common */}
          <Route path="propertySearch" element={<PropertySearchResults />} />
          <Route path="propertyPayments/:taxid/:taxyear" element={<RequireProduct product="tpay"><PropertyPaymentsPage /></RequireProduct>} />
          <Route path="history/:taxid/:taxyear/:yearshistory" element={<HistoryPage />} />
          <Route path="login" element={<LoginForm />} />
          {/* WEST-599: public, no ProtectedRoute — the emailed token is the credential */}
          <Route path="forgot-password" element={<ForgotPasswordForm />} />
          <Route path="reset-password" element={<ResetPasswordForm />} />
          <Route path="user" element={<UserLayout />}>
            <Route path="manage/:userId" element={<ProtectedRoute><UserForm /></ProtectedRoute>} />
            <Route path="list" element={<ProtectedRoute><UserList /></ProtectedRoute>} />
            <Route path="manage/new" element={<ProtectedRoute><NewUserForm /></ProtectedRoute>} />
          </Route>
          <Route path="client" element={<CustomerLayout />}>
            <Route path="manage" element={<ProtectedRoute><CustomerForm /></ProtectedRoute>} /> 
            <Route path="list" element={<ProtectedRoute><ClientList /></ProtectedRoute>} />
            <Route path="manage/new" element={<ProtectedRoute><NewCustomerForm /></ProtectedRoute>} />            
          </Route>
          <Route path="billImage/images/:customerId/:taxid/:taxyear" element={<BillImagePage />} />
          {/* Explicit Not Found route */}
          <Route path="not-found" element={<NotFound />} />
          {/* Unknown Route */}
          <Route path="*" element={<NotFound />} />
        </Route>
      </Route>
      <Route>
        <Route path="not-found" element={<NotFound />} />
      </Route>
    </Routes>
  );
}

export default App;
